export const getDayColor = (dayValue, targetValue) => {
  // Ensure the targetValue is within 1 and 6
  const adjustedTargetValue = Math.min(targetValue, 6);

  if (dayValue >= adjustedTargetValue) {
    return "#216e39"; // Dark Green
  } else if (dayValue === adjustedTargetValue - 1) {
    return "#30a14e"; // Medium Green
  } else if (dayValue === adjustedTargetValue - 2) {
    return "#40c463"; // Light Green
  } else if (dayValue === adjustedTargetValue - 3) {
    return "#9be9a8"; // Lighter Green
  } else {
    return "#ebedf0"; // Light Grey
  }
};
